export const showUpdateToast = (onReload: () => void): void => {
  if (document.getElementById("update-toast")) return;
  const toast = document.createElement("div");
  toast.id = "update-toast";
  toast.className = "update-toast";
  toast.setAttribute("role", "status");
  toast.setAttribute("aria-live", "polite");
  toast.innerHTML = `
    <span class="update-toast-text">New version available</span>
    <button class="update-toast-button" type="button">Reload</button>
  `;
  const button = toast.querySelector(".update-toast-button");
  button?.addEventListener("click", () => {
    onReload();
  });
  document.body.appendChild(toast);
  // fade in
  requestAnimationFrame(() => toast.classList.add("is-visible"));
};
